import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  vehicles: [],
};

export const getVehicles = createAsyncThunk("vehicle/fetchVehicles", () => {
  return Repo.vehicle({
    request: {
      method: "getVehiclesByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  })
    .then(({ data }) => data.response.data.vehiclesArr)
    .catch((err) => console.log(err));
});

export const vehicleSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    vehicleAdded: (state, action) => {
      let insertAt;
      if (action.payload.index || action.payload.index == 0) {
        insertAt = action.payload.index;
        delete action.payload.index;
        state.vehicles.splice(insertAt, 0, action.payload);
      } else {
        state.vehicles.unshift(action.payload);
      }
    },
    vehicleUpdated: (state, action) => {
      const { key, val } = action.payload;
      if (key == "index") {
        const { index } = action.payload;
        state.vehicles[index] = val;
      } else {
        let foundIndex = state.vehicles.findIndex(
          (item) => item._id == val._id
        );
        state.vehicles[foundIndex] = val;
      }
    },
    vehicleRemove: (state, action) => {
      const { key, val } = action.payload;
      if (key == "index") {
        state.vehicles.splice(val, 1);
      } else {
        let foundIndex = state.vehicles.findIndex((item) => item._id == val);
        state.vehicles.splice(foundIndex, 1);
      }
    },
    vehiclesClear: (state) => {
      state.vehicles = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVehicles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVehicles.fulfilled, (state, action) => {
      state.loading = false;
      state.vehicles = action.payload;
      state.error = "";
    });
    builder.addCase(getVehicles.rejected, (state, action) => {
      state.loading = false;
      state.vehicles = [];
      state.error = action.error.message;
    });
  },
});

export const { vehicleAdded, vehicleRemove, vehiclesClear, vehicleUpdated } =
  vehicleSlice.actions;

export default vehicleSlice.reducer;
